import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

type Props = {
    className?: string;
    messageId: string;
};

const ContextHeader = ({ className = '', messageId }: Props) => {
    return (
        <div className={className}>
            <StyledText
                colorPrimaryWeak
                secondary
                uppercase
            >
                {messageId && <FormattedMessage id={messageId} />}
            </StyledText>
        </div>
    );
};

export default React.memo<Props>(ContextHeader);

const StyledText = styled(Text)`
    line-height: 24px;
`;
